lmApp.controller('SessionsController', ['$routeParams', '$location', '$q', '$scope', '$interval', '$rootScope', '$templateCache', '$compile', 'ModalWindowService', '$filter', 'ToastService', 'SubscriberResource', 'AssetResource', 'SessionResource', 'ManagerResource', 'TimezoneService',
  function ($routeParams, $location, $q, $scope, $interval, $rootScope, $templateCache, $compile, ModalWindowService, $filter, ToastService, SubscriberResource, AssetResource, SessionResource, ManagerResource, TimezoneService) {
    $scope.loading = false;
    $scope.sessions = [];
    $scope.offset = 0;
    $scope.limit = 10;
    $scope.lastUpdateTime = moment();

    var timeFilter = '';
    var assetResourceTypes = {
      'dvr': 'TV catch-up',
      'hls-catchup': 'TV catch-up',
      'hls-live': 'TV live',
      'hls': 'Video on demand'
    };
    var assetResourceCache = {}; // key: resource ID, value: asset title

    // Timezone
    var timezone = _.find(TimezoneService.Timezones, {title: 'UTC'});
    $scope.tz = timezone.title;
    ManagerResource.get().$promise
      .then(function (result) {
        if (result.length !== 0) {
          var manager = _.find(result, {username: $rootScope.globals.currentUser.username});
          if (manager) {
            timezone = _.find(TimezoneService.Timezones, {title: manager.ui_timezone || 'UTC'});
            $scope.tz = timezone.title;
          }
        }
      })
      .catch(function (reason) {
        $rootScope.debugInfo(reason, 'silent');
      });

    $scope.convertTime = function (dt) {
      return TimezoneService.addTimezoneToDate(dt, timezone)
    };

    // Sessions
    var processSessions = function(sessions) {
      var result = [];
      var currentTime = moment();
      for (var i = 0; i < sessions.length; i++) {
        var session = sessions[i];
        var item = {
          subscriber: session.ticket.subscriber.username,
          contentType: 'N/A',
          contentTitle: 'N/A',
          sessionStart: session.ticket.create_time,
          sessionEnd: session.last_use_time,
          closed: !(!session.ticket.closed && currentTime.diff(moment(session.last_use_time), 'hours') < 3),
          duration: moment.utc(moment(session.last_use_time).diff(moment(session.ticket.create_time), 'seconds') * 1000).format('HH:mm:ss'),
          IP: session.ip,
          userAgent: session.ua,
          tickedId: session.ticket.id,
          sessionId: session.id
        };
        if (session.ticket) {
          if (session.ticket.device) {
            if (session.ticket.device.os) item.deviceOS = session.ticket.device.os;
            if (session.ticket.device.model) item.deviceModel = session.ticket.device.model;
          }
          if (session.ticket.asset) {
            if (session.ticket.asset.name) item.contentTitle = session.ticket.asset.name;
            if (session.ticket.asset.type) item.contentType = session.ticket.asset.type;
          }
        }
        result.push(item);
      }
      return result;
    };

    $scope.getSessions = function () {
      $scope.loading = true;
      $rootScope.showLinearProgress('#sessionLoader');

      var params = {
        '$expand': 'ticket(resource,device,subscriber,asset)',
        '$orderby': '-create_time',
        //'create_time[gt]': moment().subtract(12, 'months').format('YYYY-MM-DDTHH:mm:ss') + 'Z',
        'ticket.media_type[eq]': 'resource',
        '$limit': $scope.limit + 1,
        '$offset': $scope.offset
      };
      if (timeFilter) {
          params['create_time[gt]'] = timeFilter;
      }
      return SessionResource.get(params).$promise
        .then(function (sessions) {
          $scope.lastUpdateTime = moment();

          if (sessions.length === 0) {
            $scope.sessions = [];
            $scope.loading = false;
            $rootScope.hideLinearProgress('#sessionLoader');
            return;
          }

          var resourceIDs = [];
          for (var i = 0; i < sessions.length; i++) {
            if (!sessions[i].ticket.resource) {
              continue
            }
            if (assetResourceCache.hasOwnProperty(sessions[i].ticket.resource.id)) {
              continue
            }
            resourceIDs.push(sessions[i].ticket.resource.id);
          }
/*          if (!resourceIDs.length) {
            $scope.sessions = processSessions(sessions);
            $scope.loading = false;
            $rootScope.hideLinearProgress('#sessionLoader');
            return;
          }*/

          $scope.sessions = processSessions(sessions);
          $scope.loading = false;
          $rootScope.hideLinearProgress('#sessionLoader');

   /*       var params = {
            'resources.id[in]': resourceIDs.join(','),
            '$expand': 'resources'
          };
          AssetResource.get(params).$promise
            .then(function (assets) {
              for (var i = 0; i < assets.length; i++) {
                var asset = assets[i];
                for (var j = 0; j < asset.resources.length; j++) {
                  assetResourceCache[asset.resources[j].id] = asset.name;
                }
              }
              $scope.sessions = processSessions(sessions);
              $scope.loading = false;
              $rootScope.hideLinearProgress('#sessionLoader');
            })
            .catch(function (reason) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#sessionLoader');
              $rootScope.debugInfo(reason);
            });*/
        })
        .catch(function (reason) {
          $scope.loading = false;
          $rootScope.hideLinearProgress('#sessionLoader');
          $rootScope.debugInfo(reason);
        });
    };

    $scope.isStart = function () {
      return $scope.routePage === 1;
    };

    $scope.nextPage = function () {
      if ($scope.isEnd || $scope.loading) return;
      $scope.routePage = $scope.routePage + 1;
      $location.search('page', $scope.routePage);
      $scope.offset += $scope.limit;
      $scope.getSessions();
    };

    $scope.prevPage = function () {
      if ($scope.isStart()) return;
      if ($scope.offset >= $scope.limit) {
        $scope.offset -= $scope.limit;
        $scope.routePage = $scope.routePage - 1;
        $location.search('page', $scope.routePage);
      } else {
        $scope.offset = 0;
        $scope.routePage = 1;
        $location.search('page', 1);
      }
      $scope.getSessions();
    };

    // Chart data
    $scope.chart = {
      loading: true,
      periodStart: '',
      totalSessions: 0,
      totalUniqueUsers: 0,
      totalUniqueDevices: 0,
      totalPlayed: 0,
      sessionChartLabels: [],
      sessionChartSeries: ['Total Sessions'],
      sessionChartData: [[]],
      deviceChartLabels: ['iOS', 'Android', 'Others'],
      deviceChartData: [0, 0, 0],
      topContent: []
    };

    function duration(secs) {
      return Math.floor(moment.duration(secs,'seconds').asHours()) + 'h ' + moment.duration(secs,'seconds').minutes() + 'm ' + moment.duration(secs,'seconds').seconds() + 's';
    }
    function barChartLabelDay(t) {
      return t.utc().format('YYYY/MM/DD');
    }
    function barChartLabelDayNext(t) {
      return moment(t).add(1, 'days');
    }
    function barChartLabelHour(t) {
      return t.utc().format('YYYY/MM/DD HH') + ':00';
    }
    function barChartLabelHourNext(t) {
      return moment(t).add(1, 'hours');
    }

    var bars = {}; // label to value
    var barOrder = {}; // label to order
    var labelType = 'hour';
    var labelFunc = barChartLabelHour;

    function rangeChartBars(startdate) {
      var nextFunc = barChartLabelHourNext;
      var now = moment();
      var next = startdate;

      var hours = now.diff(startdate, 'hours');
        if (hours > 72) {
          labelFunc = barChartLabelDay;
          nextFunc = barChartLabelDayNext;
          labelType = 'day';
      }

      var order = 0;
      var label = '';
      for (var i = 0; i < 200; i++) {
        label = labelFunc(next);
        bars[label] = 0;
        barOrder[label] = order;
        order++;
        next = nextFunc(next);
        if (now.diff(next, 'hours') < 0) break;
      }
    }

    function getTop10Content(resourcePlayingTime) {
      var topContent = {};
      for (var id in resourcePlayingTime) {
        if (!assetResourceCache.hasOwnProperty(id)) {
          continue
        }
        var secs = resourcePlayingTime[id];
        var assetName = assetResourceCache[id];
        if (!topContent.hasOwnProperty(assetName)) {
          topContent[assetName] = 0;
        }
        topContent[assetName] += secs;
      }

      var sorted = [];
      for (var title in topContent) {
        sorted.push({title: title, played: topContent[title]});
      }
      sorted.sort(function(a, b) {return b.played - a.played});

      var result = [];
      var limit = sorted.length < 10 ? sorted.length : 10;
      for (var i = 0; i < limit; i++) {
        result.push({
          title: sorted[i].title,
          played: duration(sorted[i].played)
        })
      }
      return result;
    }

    $scope.getChartData = function() {
      var params = {
        '$expand': 'ticket(device)',
        '$orderby': '-create_time',
        'ticket.media_type[eq]': 'resource',
        '$limit': 1000,
        '$offset': 0
      };
      if (timeFilter) {
        params['create_time[gt]'] = timeFilter;
      }
      return SessionResource.get(params).$promise
        .then(function (sessions) {
          if (sessions.length === 0) {
            $scope.chart.loading = false;
            return;
          }

          var lastSession = sessions[sessions.length-1];
          var startdate = moment(lastSession.ticket.create_time);
          rangeChartBars(startdate);

          var uniqueDevices = {};
          var uniqueUsers = {};
          var totalPlayed = 0;
          var deviceOSCount = {ios: 0, android: 0, others: 0};
          var resourcePlayingTime = {};

          for (var i = 0; i < sessions.length; i++) {
            var session = sessions[i];
            var createTime = moment(session.ticket.create_time);

            bars[labelFunc(createTime)] += 1;
            uniqueUsers[session.ticket.subscriber.id] = true;

            var os = '';
            if (session.ticket.device && session.ticket.device.os) {
              os = session.ticket.device.os.toLowerCase();
            }
            if (session.ticket.device && session.ticket.device.id) {
              if (!uniqueDevices.hasOwnProperty(session.ticket.device.id)) {
                if ((os === 'ios' || os === 'android')) {
                  deviceOSCount[os] += 1
                } else {
                  deviceOSCount.others += 1
                }
              }
              uniqueDevices[session.ticket.device.id] = true;
            }

            var played = moment(session.last_use_time).diff(moment(session.ticket.create_time), 'seconds');
            if (session.ticket.resource) {
              if (!resourcePlayingTime.hasOwnProperty(session.ticket.resource.id)) {
                resourcePlayingTime[session.ticket.resource.id] = 0;
              }
              resourcePlayingTime[session.ticket.resource.id] += played;
            }
            totalPlayed += played;
          }

          $scope.chart.totalSessions = sessions.length;
          $scope.chart.periodStart = lastSession.ticket.create_time;
          $scope.chart.totalUniqueUsers = Object.keys(uniqueUsers).length;
          $scope.chart.totalUniqueDevices = Object.keys(uniqueDevices).length;
          $scope.chart.deviceChartData[0] = deviceOSCount.ios;
          $scope.chart.deviceChartData[1] = deviceOSCount.android;
          $scope.chart.deviceChartData[2] = deviceOSCount.others;
          $scope.chart.totalPlayed = duration(totalPlayed);

          for (var label in bars) {
            var count = bars[label];
            if (!barOrder.hasOwnProperty(label)) {
              continue
            }
            var editedLabel = label;
            if (labelType === 'hour') {
              editedLabel = moment($scope.convertTime(label)).format('YYYY/MM/DD HH') + ':00';
            }
            $scope.chart.sessionChartLabels[barOrder[label]] = editedLabel;
            $scope.chart.sessionChartData[0][barOrder[label]] = count;
          }

          // Top Content
          var resourceIDs = [];
          for (var id in resourcePlayingTime) {
            if (resourcePlayingTime[id] > 0 && !assetResourceCache.hasOwnProperty(id)) {
              resourceIDs.push(id);
            }
          }
          if (!resourceIDs.length) {
              $scope.chart.topContent = getTop10Content(resourcePlayingTime);
              $scope.chart.loading = false;
              return;
          }
          var assetParams = {
            'resources.id[in]': resourceIDs.join(','),
            '$expand': 'resources'
          };
          AssetResource.get(assetParams).$promise
            .then(function (assets) {
              for (var i = 0; i < assets.length; i++) {
                var asset = assets[i];
                for (var j = 0; j < asset.resources.length; j++) {
                  assetResourceCache[asset.resources[j].id] = asset.name;
                }
              }
              $scope.chart.topContent = getTop10Content(resourcePlayingTime);
              $scope.chart.loading = false;
            })
            .catch(function (reason) {
              $scope.chart.loading = false;
              $rootScope.debugInfo(reason);
            });
        })
        .catch(function (reason) {
          $scope.chart.loading = false;
          $rootScope.debugInfo(reason);
        });
    };

    //
    if (!_.isUndefined($routeParams.page) && $routeParams.page > 0) {
      $scope.routePage = Number($routeParams.page);
      $scope.offset = ($scope.routePage - 1) * $scope.limit;
    } else {
      $scope.routePage = 1;
    }

    $scope.getSessions();

    var params = {
      '$orderby': '-create_time',
      '$expand': 'ticket',
      'ticket.media_type[eq]': 'resource',
      '$limit': 1,
      '$offset': 1001
    };

    SessionResource.get(params).$promise
      .then(function (sessions) {
        if (sessions.length) {
          timeFilter = sessions[0].ticket.create_time;
        }
        $scope.getChartData();
      })
      .catch(function (reason) {
        $rootScope.debugInfo(reason);
      });

    $scope.updateIntreval = $interval(function () {
      $scope.getSessions();
      $scope.getChartData();
    }, 30 * 1000);

    $scope.openSession = function(session) {
      if ($scope.loading) return;

      $scope.selectedSession = session;

      var inner = $templateCache.get('session-details.tpl.html');
      inner = $compile(inner)($scope);

      $scope.window = ModalWindowService.Open({
        content: inner,
        isFixed: true,
        clear: true,
        keyboard: true,
        actions: [
          {
            title: 'Close',
            color: 'red',
            fn: function () {}
          }
        ],
        size: {
          s: 11,
          l: 8
        }
      });
    };

    $scope.$on("$destroy", function () {
      $interval.cancel($scope.updateIntreval);
    });
  }]);
